import {BaseEntity} from "./BaseEntity";

export class AlarmAck implements BaseEntity {
    constructor(public id?: number,
                public name?: string,
                public tag?: string,
                public eventType?: string,
                public thresholdType?: string,
                public assetName?: string,
                public assetDescription?: string,
                public ackTime?: string,
                public lastModifiedBy?:string) {
    }

    parseJson(json: any): void {
        this.id = json.id;
        this.name = json.name;
        this.tag = json.tag;
        this.eventType = json.eventType;
        this.thresholdType = json.thresholdType;
        this.assetName = json.assetName;
        this.assetDescription = json.assetDescription;
        this.ackTime = json.ackTime; // == null ? "" :  moment(json.ackTime).format(entities.ApplicationSetting.applicationSetting.dateFormat),
        this.lastModifiedBy = json.lastModifiedBy; // == null ? "" :  moment(json.lastModifiedBy).format(entities.ApplicationSetting.applicationSetting.dateFormat);
    }


}
